export default __webpack_public_path__ + "images/d2b141308959ba3ab4aeffb71d1424b0-EE_SlideDeckBOOK1024_11.png";